import { Switch, styled } from '@mui/material';
import OnActiveIcon from 'assets/onActiveIcon.svg';
import ActiveIcon from 'assets/activeIcon.svg';

export const MaterialUISwitch = styled(Switch)(() => ({
  width: 52,
  padding: 0,
  height: 32,
  backgroundColor: '#213B54',
  '& .MuiSwitch-switchBase': {
    margin: 2,
    marginLeft: 0.1,
    padding: 0,
    transform: 'translateX(4px)',
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url(${OnActiveIcon})`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#213B54',
      },
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: '#bdbdbd',
      opacity: 1,
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#213B54',
    width: 24,
    height: 24,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url(${ActiveIcon})`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: 'white',
    borderRadius: 20 / 2,
  },
}));
